var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { position, space, fontSize, display, flexDirection, justifyContent, alignItems, width, height, backgroundSize, backgroundPosition, backgroundRepeat, boxShadow, order, themeGet, } from 'styled-system';
import { breakpoint } from '../../common/theme/helper';
import { Grid } from '../../common/components/Grid';
import { ResponsiveLazyImage, ResponsiveLazyImagePropsShape, } from '../../common/components/LazyImage';
import { CenterRightControls, CenterLeftControls, } from '../../common/components/LazyCarouselControls';
import LazyCarousel from '../../common/components/LazyCarousel';
import { LinkButton } from '../../common/components/Link';
import { Stoerer } from '../../common/components/Stoerer';
import { DisclaimerSubscription } from '../../common/event-bus/EventSubscription';
import LegalNotesLink from './LegalNotesLink';
import CampaignInfo, { EllipsisParagraph } from './CampaignInfo';
import { getPageAppTrackerProps, } from '../../common/tracking/getTrackerProps';
import dispatchTrackingEvent from '../../common/tracking/dispatchTrackingEvent';
import { ThemedMedia } from '../../common/components/Media';
export var ButtonType;
(function (ButtonType) {
    ButtonType["Primary"] = "Primary";
    ButtonType["Secondary"] = "Secondary";
})(ButtonType || (ButtonType = {}));
var HomepageTopTeaserGrid = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
HomepageTopTeaserGrid.defaultProps = {
    px: 0,
    pb: ['40px', 6, null, '56px'],
};
var SlideContainer = styled.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  background-color: ", ";\n  text-decoration: none;\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  background-color: ", ";\n  text-decoration: none;\n"])), display, flexDirection, height, boxShadow, width, function (_a) {
    var bg = _a.bg;
    return (bg ? bg : themeGet('colors.gray.12'));
});
SlideContainer.defaultProps = {
    display: 'flex',
    flexDirection: ['column', 'row'],
    height: [368, 220, 304, 394],
    width: 1,
};
var InformationBox = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  color: ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  color: ",
    ";\n"])), display, flexDirection, justifyContent, alignItems, order, width, height, space, function (props) {
    return props.informationBoxColor
        ? props.informationBoxColor
        : themeGet('colors.gray.10');
});
InformationBox.defaultProps = {
    width: [1, '70%', null, '80%'],
    height: ['200px', 'auto'],
    pl: [0, '40px', 6, 7],
    py: [3, null, '28px', '66px'],
    display: 'flex',
    flexDirection: 'column',
    justifyContent: ['flex-start', 'space-between'],
    alignItems: ['center', 'normal'],
    order: [2, 1],
};
var Title = styled(EllipsisParagraph)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-bottom: ", "px;\n\n  ", " {\n    margin-bottom: 0;\n  }\n"], ["\n  margin-bottom: ", "px;\n\n  ", " {\n    margin-bottom: 0;\n  }\n"])), function (props) { return (props.withSubtitle ? 0 : 32); }, breakpoint(0));
Title.defaultProps = __assign(__assign({}, EllipsisParagraph.defaultProps), { as: 'h2', mx: 0, fontSize: ['22px', null, '30px', 8], lineHeight: [4, null, 5, 6], order: [1, 2] });
var Subtitle = styled(EllipsisParagraph)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), fontSize, space);
Subtitle.defaultProps = __assign(__assign({}, EllipsisParagraph.defaultProps), { as: 'p', fontSize: [4, null, 5, '22px'], mt: [1, null, 2, 3], order: [2, 3] });
var Button = styled(LinkButton)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  /* The !important is because of Shop-Reboot :'( */\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  /* The !important is because of Shop-Reboot :'( */\n  ",
    ";\n"])), order, space, width, fontSize, boxShadow, themeGet('colors.button.hover'), function (props) {
    return props.type === ButtonType.Secondary && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      color: ", " !important;\n      background-color: ", ";\n      border: 1px solid ", ";\n\n      &:hover {\n        color: ", " !important;\n        background-color: ", ";\n        border: 1px solid ", ";\n      }\n    "], ["\n      color: ", " !important;\n      background-color: ", ";\n      border: 1px solid ", ";\n\n      &:hover {\n        color: ", " !important;\n        background-color: ", ";\n        border: 1px solid ", ";\n      }\n    "])), themeGet('colors.gray.10')(props), themeGet('colors.white')(props), themeGet('colors.gray.9')(props), themeGet('colors.button.hover')(props), themeGet('colors.white')(props), themeGet('colors.button.hover')(props));
});
Button.defaultProps = __assign(__assign({}, LinkButton.defaultProps), { as: 'button', width: '160px', px: 0, py: 2, mt: [1, null, '10px', '18px'], fontSize: 4, boxShadow: 'none', order: 4 });
var RightSideWrapper = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), position, width, height, order);
RightSideWrapper.defaultProps = {
    position: 'relative',
    width: 1,
    order: [1, 2],
};
var ImageContainer = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), display, height);
ImageContainer.defaultProps = {
    height: [168, 220, 304, 394],
};
var Image = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  background-image: ", ";\n  opacity: ", ";\n  transition: opacity 0.3s ease-in-out;\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  background-image: ", ";\n  opacity: ", ";\n  transition: opacity 0.3s ease-in-out;\n"])), width, height, backgroundRepeat, backgroundPosition, backgroundSize, function (_a) {
    var image = _a.image;
    return "url(" + image + ")";
}, function (_a) {
    var show = _a.show;
    return "" + Number(show);
});
Image.defaultProps = {
    width: 1,
    height: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
};
var CarouselContainer = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  width: inherit;\n  ", ";\n"], ["\n  width: inherit;\n  ", ";\n"])), boxShadow);
CarouselContainer.defaultProps = {
    boxShadow: ['0 2px 6px 0 #c0c0c0', 'none'],
};
var HomepageTopTeaser = function (_a) {
    var items = _a.items, singleSlide = _a.singleSlide, autoPlay = _a.autoPlay;
    var _b = __read(useState(false), 2), lockScroll = _b[0], setLockScroll = _b[1];
    var _c = __read(useState(0), 2), activeSlide = _c[0], setActiveSlide = _c[1];
    var slides = singleSlide ? items.slice(0, 1) : items;
    useEffect(function () {
        var activeTopTeaserPromotion = {
            name: slides[activeSlide].tracking.name,
            placement: slides[activeSlide].tracking.placement,
            position: activeSlide,
        };
        dispatchTrackingEvent({
            event: 'promoView',
            eventAction: 'view',
            eventCategory: 'promotion',
            eventData: {
                promotions: [activeTopTeaserPromotion],
            },
        });
    }, [activeSlide, slides]);
    var onClickLegalNotes = function (_a) {
        var emit = _a.emit, html = _a.html;
        return function (event) {
            event.preventDefault();
            emit({ html: html, open: true, lockScroll: true });
        };
    };
    var handleAfterSlide = useCallback(function (currentSlide) {
        setActiveSlide(currentSlide);
    }, [activeSlide]);
    var hasMultipleSlides = slides.length > 1;
    var shouldAutoplay = autoPlay && hasMultipleSlides && !lockScroll;
    var arrowProps = {
        display: 'block',
        arrowSize: '14px',
        controlShadow: 'none',
        size: '28px',
        mx: 2,
    };
    return (React.createElement(ThemedMedia, null, function (_a) {
        var tablet = _a.tablet, desktop = _a.desktop;
        return (React.createElement(HomepageTopTeaserGrid, null,
            React.createElement(CarouselContainer, null,
                React.createElement(LazyCarousel, { showControlsOnHover: autoPlay && desktop, renderCenterLeftControls: function (props) { return (React.createElement(CenterLeftControls, __assign({}, arrowProps, props))); }, renderCenterRightControls: function (props) { return (React.createElement(CenterRightControls, __assign({}, arrowProps, props))); }, disabled: singleSlide, wrapAround: hasMultipleSlides, autoplay: shouldAutoplay, autoplayInterval: 5000, pauseOnHover: true, overflowHidden: true, afterSlide: handleAfterSlide }, slides.map(function (_a, index) {
                    var stoerer = _a.stoerer, imageProps = _a.image, campaignDuration = _a.campaignDuration, countDown = _a.countDown, title = _a.title, subtitle = _a.subtitle, cta = _a.cta, informationBoxBg = _a.informationBoxBg, informationBoxColor = _a.informationBoxColor, legalDisclaimer = _a.legalDisclaimer, _b = _a.tracking, _c = _b === void 0 ? {} : _b, name = _c.name, placement = _c.placement;
                    return (React.createElement(SlideContainer, __assign({ key: "slide-" + index, bg: informationBoxBg }, getPageAppTrackerProps(__assign(__assign({}, (index === 0 && {
                        'data-prefetch': true,
                    })), { 'data-testid': "homepage-top-teaser-slide-" + index, type: cta.type, href: cta.href }), {
                        event: 'promoClick',
                        eventData: {
                            promotions: [
                                {
                                    name: name,
                                    placement: placement,
                                    position: index,
                                },
                            ],
                        },
                    })),
                        React.createElement(InformationBox, { informationBoxColor: informationBoxColor, "data-testid": "information-box-slide" },
                            React.createElement(CampaignInfo, { duration: campaignDuration, countDown: countDown }),
                            title && (React.createElement(Title, { withSubtitle: Boolean(subtitle), "data-testid": "title" }, title)),
                            subtitle && (React.createElement(Subtitle, { "data-testid": "subtitle" }, subtitle)),
                            React.createElement(Button, { "data-testid": "button", type: cta.type }, cta.label)),
                        React.createElement(RightSideWrapper, { "data-testid": "right-side-slide" },
                            React.createElement(ImageContainer, { "data-testid": "image-container-slide" },
                                stoerer && (React.createElement(Stoerer, { label: stoerer.label, borderColor: stoerer.borderColor, themeTop: [0, 3, '28px', '66px'] })),
                                React.createElement(ResponsiveLazyImage, __assign({}, imageProps), function (_a) {
                                    var image = _a.image, thumbnail = _a.thumbnail, loaded = _a.loaded, intersected = _a.intersected, innerRef = _a.innerRef;
                                    return (React.createElement(Image, { "data-testid": "image", ref: innerRef, alt: imageProps.alt, show: intersected, image: loaded ? image : thumbnail }));
                                })),
                            legalDisclaimer && (React.createElement(DisclaimerSubscription, null, function (_a) {
                                var value = _a.value, emit = _a.emit;
                                var linkLabel = legalDisclaimer.linkLabel, linkLabelColor = legalDisclaimer.linkLabelColor, contentHtml = legalDisclaimer.contentHtml;
                                if (value.lockScroll !== lockScroll) {
                                    setLockScroll(value.lockScroll);
                                }
                                return (React.createElement(LegalNotesLink, { alignBottom: tablet, linkLabel: linkLabel, linkLabelColor: linkLabelColor, onClick: onClickLegalNotes({
                                        emit: emit,
                                        html: contentHtml,
                                    }) }));
                            })))));
                })))));
    }));
};
HomepageTopTeaser.propTypes = {
    /** A-B tests - disable multiple slides */
    singleSlide: PropTypes.bool,
    /** A-B tests - disable auto play */
    autoPlay: PropTypes.bool,
    /** Array of items */
    items: PropTypes.arrayOf(PropTypes.shape({
        /** Item's störer */
        stoerer: PropTypes.shape({
            /** Störer label */
            label: PropTypes.string,
            /** Störer border color */
            borderColor: PropTypes.string,
        }),
        /** Item's image */
        image: PropTypes.shape(__assign({ 
            /** Alternative image text. */
            alt: PropTypes.string }, ResponsiveLazyImagePropsShape)),
        /** Item's title */
        title: PropTypes.string,
        /** Item's subtitle */
        subtitle: PropTypes.string,
        /** Text to show the campaign duration */
        campaignDuration: PropTypes.string,
        /** Countdown */
        countDown: PropTypes.shape({
            /** Countdown text */
            label: PropTypes.string,
            /** Countdown end date */
            endDate: PropTypes.string,
        }),
        /** Item's CTA */
        cta: PropTypes.shape({
            /** Item's cta type */
            type: PropTypes.oneOf([ButtonType.Primary, ButtonType.Secondary]),
            /** Item's cta label */
            label: PropTypes.string,
            /** Item's cta href */
            href: PropTypes.string,
        }).isRequired,
        /** Item's information box background */
        informationBoxBg: PropTypes.string,
        /** Item's information box text color */
        informationBoxColor: PropTypes.string,
        /** Teaser legal disclaimer */
        legalDisclaimer: PropTypes.object,
        /** Tracking props */
        tracking: PropTypes.shape({
            /** Tracking item name */
            name: PropTypes.string,
            /** Tracking item placement */
            placement: PropTypes.string,
        }),
    }).isRequired),
};
HomepageTopTeaser.defaultProps = {
    autoPlay: true,
    singleSlide: false,
};
export default HomepageTopTeaser;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
